 /* eslint-disable */
import { Component, HostBinding, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { arabesqueAnimations } from '@kav/animations';
import { AppConfigService } from '@kav/services/config.service';

@Component({
    selector   : 'nav-horizontal-collapsable',
    templateUrl: './collapsable.component.html',
    styleUrls  : ['./collapsable.component.scss'],
    animations : arabesqueAnimations
})
export class NavHorizontalCollapsableComponent implements OnInit, OnDestroy
{
    @HostBinding('class')
    classes = 'nav-collapsable nav-item';
    @Input()
    item: any;
    appConfig: any;
    isOpen = false;
    private unsubscribeAll: Subject<any>;
   
    
    constructor(
        private appConfigService: AppConfigService
    )
    {
        // Set the private defaults
        this.unsubscribeAll = new Subject();
    }
      // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Open
     */
    @HostListener('mouseenter')
    open(): void
    {
        this.isOpen = true;
    }

    /**
     * Close
     */
    @HostListener('mouseleave')
    close(): void
    {
        this.isOpen = false;
    }


    // Private
 


    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        // Subscribe to config changes
        this.appConfigService.config
            .pipe(takeUntil(this.unsubscribeAll))
            .subscribe(
                (config) => {
                    this.appConfig = config;
                }
            );
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this.unsubscribeAll.next();
        this.unsubscribeAll.complete();
    }

  
}
